import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';
import MetaTags from 'react-meta-tags';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import Bar from './bar';
import Unit from './unit';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 92px;
  .wrapper {
    .products {
      display: flex;
      flex-wrap: wrap;
    }
    button.load {
      margin: 40px auto 0;
      cursor: pointer;
      max-width: 260px;
      width: 100%;
      background: #F1A857;
      display: flex;
      border-radius: 3px;
      border: 0;
      color: #fff;
      height: 60px;
      align-items: center;
      font-size: 16px;
      padding: 0;
      @media (max-width: 1080px) {
        margin: 0 auto;
      }
      span {
        height: 100%;
        flex-grow: 1;
        border-right: 1px solid #D99440;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i {
        width: 50px;
        background: url(/images/arrow-right.png) center no-repeat;
        height: 100%;
      }
    }
  }
`

const NoResults = styled.p`
  font: bold italic 30px 'Times new roman';
  text-align: center;
`

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class Products extends Component {
  state = {
    type: '',
    seo: {},
    tipo: '',
    filter: {},
    design: [],
    tonalidade: [],
    categoria: [],
    filterStatus: false,
    actual: 0,
    items: [],
    language: '',
    types: [],
    pages: 0,
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({actual: 1, tipo: this.props.match.params.category, language: language, filter: {type: this.props.match.params.type, term: this.props.match.params.term}});
    const fetchDataSeo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'seo_produtos')
      )
      if (response) {
        this.setState({seo: response.results[0].data});
      }
    }
    fetchDataSeo();
    
    window.addEventListener("scroll", this.handleScroll);

    this.getOptions();
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getOptions = () => {
    const { language } = this.context;

    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'tipo_de_produtos'),
        {lang: language}
      )
      if (response) {
        this.setState({types: response.results});
        const type = response.results.filter((item) => item.uid === this.props.match.params.category)[0]
        this.setState({type: type});
        this.getOptionByType();
      }
    }
    fetchData();
  }

  getOptionByType = () => {
    const { language } = this.context;
    const type = this.state.type;

    const fetchDataDesign = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.design_do_produto.tipo_de_produto', type.id),
        {lang: language}
      )
      if (response) {
        this.setState({design: response.results});

        if (this.props.match.params.type === 'design')
          this.getProducts();  
      }
    }
    fetchDataDesign();
    
    const fetchDataCategoria = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.categoria_produtos.tipo_de_produto', type.id),
        {lang: language}
      )
      if (response) {
        this.setState({categoria: response.results});

        if (this.props.match.params.type === 'categoria')
          this.getProducts();  
      }
    }
    fetchDataCategoria();
    
    const fetchDataTonalidade = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.tonalidade_produto.tipo_de_produto', type.id),
        {lang: language}
      )
      if (response) {
        this.setState({tonalidade: response.results});

        if (this.props.match.params.type === 'tonalidade')
          this.getProducts();  
      }
    }
    fetchDataTonalidade();

    this.getProducts();  
  }

  handleScroll = () => {
    const pos = document.querySelector("#buttonScroll")
    if (pos && (window.scrollY > pos.offsetTop - window.innerHeight)) {
      this.setState({actual: this.state.actual + 1});
      this.getProducts();
    }
  };

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      (this.state.language !== language) ||
      (!this.props.match.params.type && this.state.filter.type) ||
      (this.props.match.params.type && (this.state.filter.type !== this.props.match.params.type || this.state.filter.term !== this.props.match.params.term)) ||
      (this.props.match.params.category !== this.state.tipo)
    ) {
      window.scrollTo(0, 0)
      this.setState({language: language, actual: 1, design: [], categoria: [], tonalidade: [], items: [], tipo: this.props.match.params.category, filter: {type: this.props.match.params.type, term: this.props.match.params.term}});
      this.getOptions();  

    }
  }

  getProducts = () => {
    const type = this.state.types.filter((item) => item.uid === this.props.match.params.category)[0]
    const { language } = this.context;
    let tonalidade_id = '';
    let categoria_id = '';
    let design_id = '';
    this.state.design.map((item) => {
      if (this.props.match.params.type === 'design' && this.props.match.params.term === item.uid)
        design_id = item.id
      return true;
    });
    this.state.categoria.map((item) => {
      if (this.props.match.params.type === 'categoria' && this.props.match.params.term === item.uid)
        categoria_id = item.id
      return true;
    });
    this.state.tonalidade.map((item) => {
      if (this.props.match.params.type === 'tonalidade' && this.props.match.params.term === item.uid)
        tonalidade_id = item.id
      return true;
    });
    const page = this.state.actual;
    const fetchData = async () => {
      let query = {type: 'my.produto.tipo_de_produto', value: type.id};
      if (this.props.match.params.type) {
        switch (this.props.match.params.type) {
          case "tonalidade":
            query = {type: 'my.produto.tonalidades.tonalidade_produto', value: tonalidade_id};
            break;
          case "design":
            query = {type: 'my.produto.designs.design_produto', value: design_id};
            break;
          case "categoria":
            query = {type: 'my.produto.categoria_produto', value: categoria_id};
            break;
          default:
        }
      }
      const response = await Client.query(
        Prismic.Predicates.at(query.type, query.value),
        { pageSize : 12, page: page, lang: language }
      )
      if (response) {
        this.setState({pages: response.total_pages});
        response.results.map((item) => {
          item.category = this.state.categoria.filter((categoria) => categoria.id === item.data.categoria_produto.id)[0]
          return true;
        })
        let items = []
        items = [...this.state.items, ...response.results]
        this.setState({items: items});
      }
    }
    fetchData();
  }

  render = () => {
    const tipo_produto = this.state.types.filter((item) => item.uid === this.props.match.params.category)[0]
    const { type, filter, tipo, tonalidade, design, categoria } = this.state;
    const { language } = this.context;
    let home = ''
    let produtos = ''
    let noResults = ''
    let carregarMais = ''
    switch (language) {
      case 'pt-br':
        home = 'Início'
        produtos = 'Produtos'
        noResults = 'Nenhum produto encontrado'
        carregarMais = 'Carregar mais'
        break;
      case 'en-us':
        home = 'Home'
        produtos = 'Products'
        noResults = 'No products found'
        carregarMais = 'Load More'
        break;
      case 'es-es':
        home = 'Inicio'
        produtos = 'Produtos'
        noResults = 'No se encontraron productos'
        carregarMais = 'Ver más'
        break;
      default:
    }
    return (
      <div id="home">
        <MetaTags>
          <title>{ this.state.seo.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.seo.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.seo.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ type.data && type.data.nome[0].text } download={ type }>
          <div>
            <div>
              <Link to="/">{ home }</Link>
              <Link to={ `/produtos/${tipo_produto && tipo_produto.data.tipo.toLowerCase()}` }>{ produtos }</Link>
              <Link to={ `/produtos/${type.uid && type.uid}` }>{ type.data && type.data.nome[0].text }</Link>
            </div>
          </div>
        </Breadcrumbs>
        { 
          (tonalidade.length > 0 || design.length > 0 || categoria.length > 0) && (
            <Bar filter={ filter } type={ tipo } tonalidade={ tonalidade } design={ design } categoria={ categoria } />
          ) 
        }
        <main id="content">
          <Container>
            <div className="wrapper">
              {
                (this.state.pages === 0) && (
                  <NoResults>{ noResults }</NoResults>
                )
              } 
              <div className="products">
                {
                  this.state.items && this.state.items.map((item, index) => {
                    return item.data && (
                      <Unit {...item.data} category={ item.category ? item.category.data : null } uid={ item.uid } key={ index } />
                    )
                  })
                }
              </div>
              {
                (this.state.pages > 1 && this.state.pages > this.state.actual) && (
                  <div id="buttonScroll">
                    <button className="load">
                      <span>{ carregarMais }</span>
                      <i></i>
                    </button>
                  </div>
                )
              }
            </div>
          </Container>
        </main>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Products.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Products.contextType = LanguageContext;

export default Products;
